import { render } from "./ExchangeFile.vue?vue&type=template&id=6d779955&scoped=true"
import script from "./ExchangeFile.vue?vue&type=script&lang=js"
export * from "./ExchangeFile.vue?vue&type=script&lang=js"

import "./ExchangeFile.vue?vue&type=style&index=0&id=6d779955&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d779955"]])

export default __exports__